import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const Marker = ({}) => <div className="custom-marker"></div>;

function createMapOptions(maps) {
    return {
        fullscreenControl: false,
        mapTypeControl: false,
        // styles: [
        //     {
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#f5f5f5"
        //         }
        //       ]
        //     },
        //     {
        //       "elementType": "labels.icon",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#616161"
        //         }
        //       ]
        //     },
        //     {
        //       "elementType": "labels.text.stroke",
        //       "stylers": [
        //         {
        //           "color": "#f5f5f5"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "administrative.land_parcel",
        //       "elementType": "labels",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "administrative.land_parcel",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#bdbdbd"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "landscape",
        //       "elementType": "geometry.fill",
        //       "stylers": [
        //         {
        //           "color": "#ffffff"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "landscape.man_made",
        //       "elementType": "geometry.stroke",
        //       "stylers": [
        //         {
        //           "color": "#333333"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#eeeeee"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi",
        //       "elementType": "labels.text",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#757575"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi.business",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi.park",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#e5e5e5"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi.park",
        //       "elementType": "labels.text",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "poi.park",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#9e9e9e"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#ffffff"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road",
        //       "elementType": "geometry.fill",
        //       "stylers": [
        //         {
        //           "color": "#ebebeb"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road.arterial",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#757575"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road.highway",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#dadada"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road.highway",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#616161"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road.local",
        //       "elementType": "labels",
        //       "stylers": [
        //         {
        //           "visibility": "off"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "road.local",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#9e9e9e"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "transit.line",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#e5e5e5"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "transit.station",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#eeeeee"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "water",
        //       "elementType": "geometry",
        //       "stylers": [
        //         {
        //           "color": "#c9c9c9"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "water",
        //       "elementType": "geometry.fill",
        //       "stylers": [
        //         {
        //           "color": "#4d7ea8"
        //         }
        //       ]
        //     },
        //     {
        //       "featureType": "water",
        //       "elementType": "labels.text.fill",
        //       "stylers": [
        //         {
        //           "color": "#9e9e9e"
        //         }
        //       ]
        //     }
        //   ],
        zoomControl: false,
        zoomControlOptions: {
            position: maps.ControlPosition.RIGHT_CENTER,
            style: maps.ZoomControlStyle.SMALL
        }
    };
}

class SimpleMap extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    static defaultProps = {
        center: {
            lat: 1.786718,
            lng: 1.994594
        },
        zoom: 12,
    };

    render() {
        return (
            // Important! Always set the container height explicitly // KEY: AIzaSyCxFgrrbBDujcMaDnILWebpFCBB0fx8OB0
            <div style={{ height: '100%', width: '100%' }}>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: "AIzaSyCxFgrrbBDujcMaDnILWebpFCBB0fx8OB0" }}
                    defaultCenter={this.props.center}
                    center={{
                        lat: this.props.lat,
                        lng: this.props.lng
                    }}
                    defaultZoom={this.props.zoom}
                    options={createMapOptions}
                    yesIWantToUseGoogleMapApiInternals={true}
                >
                    <Marker
                        lat={this.props.lat}
                        lng={this.props.lng}
                    />
                </GoogleMapReact>
            </div>
        );
    }
}

export default SimpleMap;
